import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ReturnIconSvg from './icon-return.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ReturnIconSvg {...validProps} />;
}
SvgComponent.iconName = 'returnIcon';

/**
 * @deprecated This is a legacy icon
 */
export const ReturnIcon = svgIconWrapper(SvgComponent);
